import { IRootState } from "../../rootReducer";

export function getFontSize(state: IRootState): number {
  return state.display.fontSize;
}

export function getIsEdit(state: IRootState): boolean {
  return state.display.isEdit;
}

export const getIsOrigin = (state: IRootState): boolean => state.display.isOrigin;

export function getLeftSideWidth(state: IRootState): number {
  return state.display.leftSideWidth;
}

export function getWidths(state: IRootState) {
  const {
    display: {
      leftSideWidth,
      rightSideWidth,
    },
  } = state;

  return ({
    widthLeft: leftSideWidth,
    widthRight: 100 - rightSideWidth,
  });
}

export function getRightSideWidth(state: IRootState): number {
  const { display: { leftSideWidth, rightSideWidth } } = state;

  return 100 * (rightSideWidth / (100 - leftSideWidth));
}

export const getRightSideWidthAlt = (state: IRootState): number => state.display.rightSideWidth;
